export default {
  error_messages: {
    orders_disabled: 'Comanda nu este posibilă momentan',
  },
};
